module.exports = "dist/94998475f6aea65f558494802416c1cf.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Thin.ttf
// module id = 206
// module chunks = 0